module.exports = __webpack_public_path__ + "img/map-icon.f7b4fca6.svg";